import React, { useCallback, useRef, useState } from 'react';
import { useTranslation } from "react-i18next";

import { emailRegExp } from '../../utils/utilityEtc';

function WorksheetEmailPopup({ 
  isGuest, 
  email, 
  worksheetEmailSendAPICall,
  handleEmailSendPopup,
}) {
  const { t } = useTranslation();
  const checkbox = useRef(null);
  const inputEmail = useRef(null);
  const [checked, setChecked] = useState('');
  const [msg, setMsg] = useState('');


  const handleEmailBtn = useCallback(() => {

    const e = inputEmail.current.value
    let eMsg = '';
    if (!e) eMsg = t("MY_06_03.msg004");
    else if (!emailRegExp(e)) eMsg = t("api_error.msg019");
    else if (!checkbox.current.checked) eMsg = t("LC_05_07_01.msg024");

    if (eMsg) {
      setMsg(eMsg);
      setChecked('on');
      return;
    }

    setChecked('off');
    worksheetEmailSendAPICall('2', e);

  }, []);
  return (
    isGuest.current
      ? (
        <div className="email_pop">
          <div className="lp-wrap lp-middle">
            <div className="lp-container lc-alert lc-def">
              <div className="email_content">
                <p className="txt">{t("MY_00.msg010")}</p>
                <div className="input_box blue_line">
                  <label htmlFor="email">이메일 주소</label>
                  <input 
                    type="email" 
                    id="email"  
                    ref={inputEmail}
                    placeholder={t("MY_00.msg002")}
                  />
                </div>
                {
                  (checked === 'on') && (
                    <div style={{ textAlign: 'center' }}>
                      <span style={{ fontSize: 10, color: 'red' }}>
                        {msg}
                      </span>
                    </div>
                  )
                }
                <div className="custom-radio-wrap gray">
                  
                  <input type="checkbox" id="input-chk4" ref={checkbox} />
                  <label htmlFor="input-chk4">{t("MY_00.msg011")}</label>
                </div>
                <div className="lp-btnBox">
                  <button 
                    className="btn h40 btn-blue"
                    onClick={handleEmailBtn}
                  >
                    {t("MY_00.msg012")}
                  </button>
                </div>
              </div>
              <button 
                type="button" 
                id="close" 
                className="btn close"
                onClick={handleEmailSendPopup}
              >
                <span className="blind">닫기</span>
              </button>
            </div>
          </div>
        </div>
      )
      : (
        <div className="email_pop">
          <div className="lp-wrap lp-middle">
            <div className="lp-container lc-alert lc-def">
              <div className="email_content email_confirm">
                <p className="txt" dangerouslySetInnerHTML={{ __html: t("MY_00.msg013", { email: email.current }) }} />
                <div className="lp-btnBox">
                  <button 
                    className="btn h40 btn-blue"
                    onClick={handleEmailSendPopup}
                  >
                    {t("MY_03_06.msg004")}
                  </button>
                </div>
              </div>

              <button 
                type="button" 
                id="close" 
                className="btn close"
                onClick={handleEmailSendPopup}
              >
                <span className="blind">닫기</span>
              </button>
            </div>
          </div>
        </div>
      )
  );
}

export default WorksheetEmailPopup;